import { genreCategories } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

export default function GenreBrowse() {
  return (
    <section id="genres" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="电影大全 · 按题材浏览"
          title="从题材入口发现更多影片"
          desc="电影大全按内容划分题材，每个分类下的影片数量持续增长。先从感兴趣的类型开始，更容易找到想要的那一部。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {genreCategories.map((g) => (
            <a
              key={g.id}
              href="#hot"
              className="group p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-secondary-400 transition-colors"
            >
              <div className="flex items-start justify-between">
                <span className="w-12 h-12 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center">
                  <i className={`${g.icon} text-2xl`}></i>
                </span>
                <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium">
                  {g.count} 部
                </span>
              </div>
              <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">{g.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-secondary-700">
                查看该分类
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}